

(function(){

    angular.module('tmx-app').controller('companyCtrl', ['$scope', '$state','CompanyService','$mdSidenav','tmxUtility','menu', 
   
        function CompanyCtrl($scope, $state, CompanyService, $mdSidenav,tmxUtility,menu){
  
            var companyVM=this;
            var exists;
            var copy;
            companyVM.EntityName = "Company";
     
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
    ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            companyVM.menu = menu;
            companyVM.Privileges = [];
            companyVM.ViewPrivilege = false;
            companyVM.EditPrivilege = false;
            companyVM.DeletePrivilege = false;
            companyVM.AddPrivilege = false;
            companyVM.checkPermission = tmxUtility.checkPermission;
     
            companyVM.CurrentEntityPrivileges = JSON.parse(localStorage.getItem("CurrentEntityPrivileges"));
            if(angular.isDefined(companyVM.CurrentEntityPrivileges) && companyVM.CurrentEntityPrivileges!=null &&
                          companyVM.CurrentEntityPrivileges.EntityName ==  companyVM.EntityName){
                companyVM.ViewPrivilege = companyVM.CurrentEntityPrivileges.ViewPrivilege;
                companyVM.EditPrivilege = companyVM.CurrentEntityPrivileges.EditPrivilege;
                companyVM.DeletePrivilege = companyVM.CurrentEntityPrivileges.DeletePrivilege;
                companyVM.AddPrivilege = companyVM.CurrentEntityPrivileges.AddPrivilege;
        //localStorage.removeItem('CurrentEntityPrivileges');
            }
            companyVM.getMenu = function() {
                if(angular.isDefined(menu.pages.sections)){
                    for(var i=0;i<menu.pages.sections.length;i++){
                        var section = menu.pages.sections[i];
                        if(angular.isDefined(section.pages) && section.pages != null && section.pages.length>0){
                            for(var j=0;j<section.pages.length;j++){
                                if(section.pages[j].name ==  companyVM.EntityName){
                                    return section.pages[j];
                                }
                            }
                        }
                    }
                }
                return undefined;
            };
            companyVM.menuChanged = function(newMenuSection) {
         
                if(!angular.isDefined(newMenuSection)){return;}
                companyVM.ViewPrivilege = false;
                companyVM.EditPrivilege = false;
                companyVM.DeletePrivilege = false;
                companyVM.AddPrivilege = false;

                companyVM.customerMenuSection = newMenuSection;//sections in the menu
                companyVM.Privileges = angular.copy(companyVM.customerMenuSection.privileges);

                if(angular.isDefined(companyVM.Privileges)) {
                    for (var i = 0; i < companyVM.Privileges.length; i++) {
                        var privilege = companyVM.Privileges[i];
                 

                        if (privilege.PrivilegesId == 54) {// VIEW Customer
                            companyVM.ViewPrivilege = true;
                        }
                        else if (privilege.PrivilegesId == 55) {//EDIT Customer
                            companyVM.EditPrivilege = true;
                        }
                        else if (privilege.PrivilegesId == 57) {//DELETE Customer
                            companyVM.DeletePrivilege = true;
                        }
                        else if (privilege.PrivilegesId == 58) {//CREATE Customer
                            companyVM.AddPrivilege = true;
                        }

                    }

                    companyVM.CurrentEntityPrivileges = {
                        EntityName: companyVM.customerMenuSection.name, //name of entity from secion.json
                        ViewPrivilege: companyVM.ViewPrivilege,
                        EditPrivilege: companyVM.EditPrivilege,
                        DeletePrivilege: companyVM.DeletePrivilege,
                        AddPrivilege: companyVM.AddPrivilege
                    };
                    localStorage.setItem("CurrentEntityPrivileges", JSON.stringify(companyVM.CurrentEntityPrivileges));
             
            //customerVM.reload();
                }
            };
            $scope.$watch(companyVM.getMenu, companyVM.menuChanged,true);
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            companyVM.query = "Company";
            companyVM.gridData = new kendo.data.ObservableArray([]);
            companyVM.date = new Date().toJSON();
            companyVM.cols = CompanyService.filterColumn;
            companyVM.nav = "SearchSideNav";
            companyVM.schema = CompanyService.schema;
            companyVM.cloneColumn = CompanyService.gridColumn;
            companyVM.CompanyService = CompanyService;
            companyVM.promise;

  //*************Functions**************** 
            companyVM.reload=function(){
                companyVM.container.companyGrid.dataSource.read();
            }
            companyVM.checkAddDisabled = function(){
                if($mdSidenav(companyVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
/////////////////////////// FILTERED FUNCTION TO APPLY FA-FILTER ICON on SEARCH RESULTS///////////////////////////////
            companyVM.isFiltered=function(fieldName){
       
                var filtered = false;
                if(fieldName == "Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(companyVM.filters)){
                    companyVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName){
                            filtered = true;
                        }
                    });
                }
                return filtered;
            };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            companyVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            }  

            companyVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };

            companyVM.new = function(){
    //companyVM.searchClear = true;
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".add");
            };

            companyVM.clickEdit = function (item) {  
    //companyVM.searchClear = true;
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyId});
            };

            companyVM.clickView = function (item) {
      //companyVM.searchClear = true;
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyId});
            };

 //  companyVM.clickActive = function (item) {   
 //     var confirm = $mdDialog.confirm()
 //              .title('Activate Company '+item.CompanyName+" ?")
 //              .textContent('Are you sure you want to activate this company?')
 //              .ariaLabel('Lucky day')
 //              .clickOutsideToClose(true)
 //              // .targetEvent(ev)
 //              .ok('Yes')
 //              .cancel('Cancel');

 //        $mdDialog.show(confirm).then(function() {
 //            item.$activate(item.CompanyId).then(function(result)
 //            {
 //              companyVM.container.companyGrid.dataSource.read();
 //            });
 //        }, function() {

 //    });
 // }     

  // companyVM.clickInactive = function (item) {   
  //          var confirm = $mdDialog.confirm()
  //             .title('Deactivate Company '+item.CompanyName+" ?")
  //             .textContent('Are you sure you want to deactivate this company?')
  //             .ariaLabel('Lucky day')
  //             .clickOutsideToClose(true)
  //             // .targetEvent(ev)
  //             .ok('Yes')
  //             .cancel('Cancel');

  //       $mdDialog.show(confirm).then(function() {
  //           item.$deactivate(item.CompanyId).then(function(result)
  //           {
  //             companyVM.container.companyGrid.dataSource.read();
  //           });
  //       }, function() {

  //   }); 
           
  // }     
 

//*******************Kendo row template functions****************************

            companyVM.dataObj ={
                value: "empty"}
 
            companyVM.isStatusActive=function(dataitem){
                if(dataitem.Status == "Active"){
                    return true;
                }
                return false;
            };

            companyVM.status=function(dataitem){
                return dataitem.Status;
  //if(dataitem.EffectiveEndDate<companyVM.date)
  //{
  //  return "Inactive";
  //}
  //return "Active";
            };

            companyVM.getCompanyType=function(dataitem){
                if(angular.isDefined(CompanyService.lookup.type) && CompanyService.lookup.type.length>0) {
                    for (var i = CompanyService.lookup.type.length - 1; i >= 0; i--) {
                        if(CompanyService.lookup.type[i].HiddenValue==dataitem.CompanyTypeLkp) {
                            return CompanyService.lookup.type[i].VisibleValue;
                        }
                    }
                }  
                return "none";
            }

            companyVM.formatCompanyName=function(dataitem) {
                return  tmxUtility.sliceText(dataitem.CompanyName,25);
            };

            companyVM.getCompanyClass=function(dataitem){
                if(angular.isDefined(CompanyService.lookup.classification) && CompanyService.lookup.classification.length>0) {
                    for (var i = CompanyService.lookup.classification.length - 1; i >= 0; i--) {
                        if(CompanyService.lookup.classification[i].HiddenValue==dataitem.CompanyClassificationLkp) {
                            return CompanyService.lookup.classification[i].VisibleValue;
                        }
                    }
                } 
                return "none";
            }

            companyVM.getContactPerson=function(dataitem){
                if(angular.isDefined(dataitem.ContactPersonName) && dataitem.ContactPersonName!=null) {
                    return dataitem.ContactPersonName;
                }
                return "N/A";
            }  

            companyVM.getContactPhoneNumber=function(dataitem){
  
                if(angular.isDefined(dataitem.PhoneNumber1) && dataitem.PhoneNumber1!=null) {
                    return "+"+dataitem.PhoneNumber1;
      //var country, city, number, ext;
      //  country = dataitem.PhoneNumber1.slice(0,2);
      //  city = dataitem.PhoneNumber1.slice(2,5);
      //  number = dataitem.PhoneNumber1.slice(5);
      //  number = number.slice(0, 3) + '-' + number.slice(3,7);
      //  return "+"+country+" (" +city+") "+number;
                }
                return "N/A";
            };

            companyVM.getCompanyCode=function(dataitem) {
                return  dataitem.CompanyCode;
            };
//*******************KENDO*********************//

            companyVM.gridColumns = CompanyService.columns;
            companyVM.filters = {};
            companyVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o){
                     
                            if(angular.isDefined(companyVM.searchClear) && companyVM.searchClear==false){
                                if(exists(companyVM.o)){
                                    copy(companyVM.o.data,["filter"],o.data);
                                }
                            }
                            companyVM.searchClear = false;
                            if(companyVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    companyVM.searchClear = true;
                                    $state.searchClear=undefined;
                            //return;
                                }

                            }
                            else{
                                o.data.firstPage = true;
                            }

                            companyVM.o = angular.copy(o);
                            companyVM.filters = companyVM.o.data.filter;
                     

                            var promise=CompanyService.getByParams(o,true);
                            promise.then(function(response){
                                companyVM.kendoResponse = angular.copy(response);
                                if(!angular.isDefined(response) || !angular.isDefined(response.data))return;

                    ////MAIN GRID DATA FETCH
                    //if(angular.isDefined(response.data) && response.data.length != 0){
                    //          showCustomToast("success","Companies List has been fetched successfully");
                    //}
                      //companyVM.GridResponse = response.data;

                                for(var i=0; i<response.data.length; i++) {
                                    if(response.data[i].TmXCompanyContactPerson==null) {
                                        response.data[i].TmXCompanyContactPerson = {}; 
                                    }
                                }

                                o.success(response);
                            });
                            return promise;
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: [{field: "CompanyId", dir: "desc"}]
            // sort:  [{field: "EffectiveEndDate", dir: "desc"}/*,{field: "CreatedDate", dir: "desc"}*/],
                },
        // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "Companies.pdf"
                },
                excel: {
/*
          allPages: true,
*/
                    fileName: "Companies.xlsx"
                },
          // filterable:true,
                sortable: true,
                scrollable: false,
                rowTemplate: kendo.template($("#rowTemplate").html()),
                columns: CompanyService.columns
            };

            companyVM.container = {};
            $state.data={
                grid: companyVM.container,
                info: false
            };
//////////////////////////////////////Function to apply class to grid footer ////////////////////////////////////////////
            companyVM.isGridEmpty = function(){

            };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//*************Filter******************//
            companyVM.toggle = function(navID) {

                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };

            companyVM.filt = {};
    

            companyVM.search = function(navID) {      
                let calls=[];
  

                for (var key in companyVM.searchData) {
                    if (companyVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value:companyVM.searchData[key]
                        });
                    }
                }

                companyVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                companyVM.o.data.filter = companyVM.filt;
                companyVM.container.companyGrid.dataSource.transport.read(companyVM.o);

                companyVM.searchData = {};
                companyVM.toggle(navID);
            };

            companyVM.clear = function(navID) {
                companyVM.searchData = {};
                companyVM.toggle(navID);
            };
        }]);

})();
